import { render, staticRenderFns } from "./CreateAccountView.vue?vue&type=template&id=0aba7b3a"
import script from "./CreateAccountView.vue?vue&type=script&lang=js"
export * from "./CreateAccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports